export default "__VITE_ASSET__BoEiPkzT__"